import { render, staticRenderFns } from "./TransactionsViewStandard.vue?vue&type=template&id=3d88db83"
import script from "./TransactionsViewStandard.vue?vue&type=script&lang=js"
export * from "./TransactionsViewStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports